import { DOCUMENT } from "@angular/common";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LogClass, Logger } from "../logger";

@Injectable({
  providedIn: "root"
})
@LogClass({ source: "ApiInterceptor" })
export class ApiInterceptor implements HttpInterceptor {
  private logger: Logger;

  constructor(@Inject(DOCUMENT) private document: HTMLDocument) {
    this.logger.debug("ctor");
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // to modify header it's necessary to clone the req and provide the modified headers.
    return next.handle(req);
  }
}
